import { Radio } from 'lucide-react'

import deezerIcon from '@/assets/providers/deezer.svg'
import youtubeIcon from '@/assets/providers/youtube.svg'
import { cn } from '@/lib/cn'

const icons: Record<string, string> = {
  youtube: youtubeIcon,
  deezer: deezerIcon,
}

/** Decorative brand mark; the surrounding control or badge supplies its name. */
export function ProviderIcon({ provider, className }: { provider: string; className?: string }) {
  const icon = icons[provider]
  if (!icon) return <Radio className={cn('h-4 w-4 shrink-0', className)} aria-hidden="true" />

  return (
    <img
      src={icon}
      alt=""
      aria-hidden="true"
      className={cn('h-4 w-4 shrink-0', className)}
    />
  )
}

export function ProviderBadge({ provider, name }: { provider: string; name: string }) {
  return (
    <span
      aria-label={`Source: ${name}`}
      title={`Source: ${name}`}
      className="mx-1 inline-flex shrink-0 items-center gap-1.5 rounded-md border border-border px-1.5 py-1 text-xs text-text-muted"
    >
      <ProviderIcon provider={provider} />
      <span aria-hidden="true" className="hidden sm:inline">{name}</span>
    </span>
  )
}
